import { useGroupsOverviewListQuery } from 'core/graphql';

import { usePageVisiblePoll } from '../Meta/usePageVisiblePoll';

export interface IGroupOverview {
  groupId: string;
  name: string;
  course: string;
  startDate: string | null;
  /** Дата последнего занятия; null у группы без занятий — такая считается
   *  ИДУЩЕЙ (то же правило, что у серверного `activeWithinDays`). */
  lastLessonDate: string | null;
  studentsCount: number;
  /** ТЗ 0036 — только ПРОСРОЧЕННЫЙ план, не весь неоплаченный. */
  debtTotal: number;
  debtCurrency: string;
  /** План, срок которого ещё не наступил, — в долг не входит. */
  upcomingTotal: number;
  debtorsCount: number;
  unhandledStudentsCount: number;
  unreadStudentsCount: number;
  /** Total unread messages across the group's channels + members' dialogs. */
  unreadMessagesCount: number;
  openTasksCount: number;
  overdueTasksCount: number;
}

interface IUseGroupsOverview {
  groups: IGroupOverview[];
  loading: boolean;
}

/**
 * Account-manager command-center rollup (spec 0003 redesign): one row per
 * group with REAL (contribution-based) debt + unhandled/task signals.
 */
export const useGroupsOverview = (
  search?: string,
  onlyIssues?: boolean,
  pollInterval?: number,
  /** ТЗ 0031: оставить только группы с занятием за последние N дней (плюс те,
   *  у кого занятий ещё нет). Передаёт ТОЛЬКО коммуникатор — командный центр
   *  суммирует KPI по всем группам, и молчаливая фильтрация поехала бы по
   *  итогам долгов и задач. */
  activeWithinDays?: number | null,
): IUseGroupsOverview => {
  const {
    data,
    loading,
    startPolling,
    stopPolling,
  } = useGroupsOverviewListQuery({
    variables: {
      search: search || null,
      onlyIssues: Boolean(onlyIssues),
      activeWithinDays: activeWithinDays ?? null,
    },
    fetchPolicy: 'cache-and-network',
  });
  // Visibility-aware polling (spec 0008): a backgrounded tab must not keep
  // re-running the cross-group rollup.
  usePageVisiblePoll(
    startPolling,
    stopPolling,
    pollInterval || 0,
    Boolean(pollInterval),
  );
  return {
    groups: (data?.groupsOverview || []) as IGroupOverview[],
    loading,
  };
};
